import $ from "jquery";
import 'slick-carousel';

const clientSlider = (isAutoplay = true, currentSlide = 0) => {
  let slider = $('[data-slider=clients]');

  if (slider.hasClass('slick-initialized')) {
    slider.slick('unslick');
  }

  const slidesToShow = slider.data('slides-to-show') || 7;

  slider.slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: isAutoplay,
    variableWidth: true,
    cssEase: 'linear',
    initialSlide: currentSlide,
    autoplaySpeed: 0,
    speed: 6000,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
};

export default clientSlider;
